import React, { useState } from 'react'
import Collapsible from 'react-collapsible';
import styles from '../Components/Certifications.module.css'
import { TbCertificate } from "react-icons/tb";
import CertificationsEachWrapper from './CertificationsEachWrapper';


const Certifications = props => {
    const { data } = props
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={styles.mainWrapper}>
            <Collapsible trigger={
                <div className={isOpen === true ? styles.mainHeaderOpen : styles.mainHeader}>
                    <div className={styles.leftCol}>
                        <TbCertificate />
                        <span className={styles.headerTitle}>
                            Certi / Diplomas
                        </span>
                    </div>
                    <div className={styles.rightCol}>

                    </div>
                </div>
            }
                isOpen={false}
                onOpening={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
            >

                <div className={styles.mainContainer}>
                    {data?.map((item, index) => (
                        <CertificationsEachWrapper
                            key={index}
                            item={item}
                        />
                    ))}
                </div>
            </Collapsible>
        </div>
    )
}

export default Certifications